import CompreJuntoProvider from './hooks/useCompreJunto';
import CompreJuntoContainer from './handles/CompreJuntoContainer';
import { CompreJuntoProps } from './@types/CompreJuntoProps';
import './CompreJunto.scss';

const CompreJunto = (props: CompreJuntoProps) => (
	<CompreJuntoProvider {...props}>
		<CompreJuntoContainer>{props.children}</CompreJuntoContainer>
	</CompreJuntoProvider>
);

export default CompreJunto;
